"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPalette = void 0;
var createPalette_1 = __importDefault(require("@material-ui/core/styles/createPalette"));
// eslint-disable-next-line no-restricted-imports
var colors_1 = require("@material-ui/core/colors");
var utils_1 = require("@material-ui/utils");
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var offBlack = "#141414";
var darkColors = {
    background: {
        default: offBlack,
        paper: "#272727",
        overlays: "#3A3A3A",
    },
    secondary: {
        main: "#3A3A3A",
    },
    divider: colorManipulator_1.fade(colors_1.common.white, 0.16),
    dividerStrong: colorManipulator_1.fade(colors_1.common.white, 0.32),
    text: {
        primary: colors_1.common.white,
        secondary: colorManipulator_1.fade(colors_1.common.white, 0.72),
    },
    action: {
        active: colorManipulator_1.fade(colors_1.common.white, 0.24),
        hover: colorManipulator_1.fade(colors_1.common.white, 0.16),
        focus: colorManipulator_1.fade(colors_1.common.white, 0.16),
        selected: colorManipulator_1.fade(colors_1.common.white, 0.08),
    },
};
var lightColors = {
    background: {
        default: colors_1.common.white,
        paper: "#F2F2F2",
        overlays: colors_1.common.white,
    },
    secondary: {
        main: "#E6E6E6",
    },
    divider: colorManipulator_1.fade(offBlack, 0.16),
    dividerStrong: colorManipulator_1.fade(offBlack, 0.32),
    text: {
        primary: offBlack,
        secondary: colorManipulator_1.fade(offBlack, 0.72),
    },
    action: {
        active: colorManipulator_1.fade(offBlack, 0.24),
        hover: colorManipulator_1.fade(offBlack, 0.16),
        focus: colorManipulator_1.fade(offBlack, 0.16),
        selected: colorManipulator_1.fade(offBlack, 0.08),
    },
};
var getDefaultColors = function (type) {
    return utils_1.deepmerge({
        type: type,
        primary: {
            main: "#0074E4",
            light: "#339BFF",
        },
        success: {
            main: "#0B873A",
            light: "#11CF59",
        },
        warning: {
            main: "#FFA640",
            light: "#FFCB8F",
            contrastText: colors_1.common.black,
        },
        error: {
            main: "#DE3341",
            light: "#E97780",
        },
        info: {
            main: "#6C5BB7",
            light: "#9D91CF",
        },
        common: { offBlack: offBlack },
        action: {
            hoverOpacity: 0.16,
            focusOpacity: 0.16,
            selectedOpacity: 0.08,
            disabledOpacity: 0.5,
            activatedOpacity: 0.24,
        },
    }, type === "dark" ? darkColors : lightColors, { clone: false });
};
var createPalette = function (_a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.type, type = _b === void 0 ? "dark" : _b, options = __rest(_a, ["type"]);
    return createPalette_1.default(utils_1.deepmerge(getDefaultColors(type), options, { clone: false }));
};
exports.createPalette = createPalette;
//# sourceMappingURL=createPalette.js.map